import { Repasse } from '../models';
import { makeCrudObject } from './api';

export default makeCrudObject<Repasse>('repasse');
